<template>
  <div>
    <tabelas-header
      :titulo="nomeDoPlano"
      texto1="Tabela de procedimentos passíveis da cobrança de coparticipação"
      texto2="Tabela de Referência - Padrão"
    />
    <div class="buttons">
      <button class="button-voltar" @click="voltar">
        <b-icon icon="arrow-left"> </b-icon>
        Voltar
      </button>
      <a href="#ancora-faq" class="titulo-link-ancora">
        <div class="container card-header-title-coparticipacao">
          <font class="icone-interrogacao">?</font>&nbsp;&nbsp;Perguntas
          frequentes sobre coparticipação
        </div>
      </a>
    </div>
    <div class="card-pesquisa">
      <div class="card-container pesquisa-item">
        <pesquisa
          label="Buscar"
          placeHolder="Digite o item desejado"
          v-model="filtro"
          :click="filtrarTabela"
        />
      </div>
    </div>
    <div class="card-tabelas">
      <div class="mensagem" v-if="isShowMessage">Nenhum item encontrado.</div>
      <b-skeleton-table
        class="table-skeleton"
        :columns="4"
        v-if="isShowSkeleton"
      >
      </b-skeleton-table>
      <b-skeleton
        v-if="isShowSkeleton"
        class="block-skeleton"
        width="100%"
      ></b-skeleton>
      <b-skeleton
        v-if="isShowSkeleton"
        class="block-skeleton"
        width="100%"
      ></b-skeleton>
      <b-skeleton
        v-if="isShowSkeleton"
        class="block-skeleton"
        width="100%"
      ></b-skeleton>
      <b-skeleton
        v-if="isShowSkeleton"
        class="block-skeleton"
        width="100%"
      ></b-skeleton>
      <b-table
        id="tabelaCoparticipacao"
        striped
        hover
        stacked="md"
        :fields="fields"
        :items="filtrarTabela"
        :per-page="perPage"
        :current-page="currentPage"
        :skeleton-rows="true"
        fixed
        v-if="isShowTabela"
        class="table-responsive"
      >
      </b-table>
      <b-pagination
        v-if="this.rows > this.perPage"
        v-model="currentPage"
        class="custom-pagination"
        :per-page="perPage"
        :total-rows="rows"
        align="center"
        prev-text="Anterior"
        next-text="Próximo"
        limit="5"
        hide-ellipsis
        hide-goto-end-buttons
      >
      </b-pagination>
    </div>
    <faq-coparticipacao />
  </div>
</template>

<script>
import Pesquisa from "../components/pesquisa/Pesquisa";
import Header from "../components/header/Header.vue";
import { API_URL } from "../http/base-urls";
import axios from "../http/index.js";
import Faq from "../components/faq/Faq";

export default {
  components: {
    Pesquisa,
    "tabelas-header": Header,
    "faq-coparticipacao": Faq,
  },
  data() {
    return {
      filtro: "",
      rows: 0,
      perPage: 100,
      currentPage: 1,
      isShowTabela: false,
      isShowMessage: false,
      isShowSkeleton: true,
      isShowPagination: true,
      isErro: false,
      nomeDoPlano: "",
      itens: [],
      fields: [
        {
          label: "CÓDIGO",
          key: "CodItem",
          thStyle: { width: "10%" },
        },
        {
          label: "PROCEDIMENTO",
          key: "Tabela",
          thStyle: { width: "20%" },
        },
        {
          label: "DESCRIÇÃO",
          key: "DescItem",
          thStyle: { width: "55%" },
        },
        {
          label: "VALOR TOTAL(R$)",
          key: "ValorItem",
          thStyle: { width: "15%" },
        },
      ],
    };
  },
  mounted() {
    this.plano = JSON.parse(localStorage.getItem("Plano"));
    this.nomeDoPlano = this.plano.nome;

    var config = {
      method: "get",
      url: `${API_URL}/customer/ObterTabelaCopart?tabela=${this.plano.tabela}`,
    };

    axios(config)
      .then((response) => {
        this.itens = response.data;
        this.rows = this.itens.length;
        this.isShowTabelaCoparticipacao = true;
        this.isShowSkeleton = false;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  computed: {
    filtrarTabela() {
      if (this.isShowSkeleton) return;

      let itensFiltrado = this.itens;

      if (this.filtro) {
        let exp = new RegExp(this.filtro.trim(), "i");
        itensFiltrado = this.itens.filter((tabela) =>
          exp.test(tabela.DescItem)
        );

        this.currentPage = 1;
      }

      this.rows = itensFiltrado.length;
      this.isShowMessage =
        itensFiltrado.length < 1 &&
        (!this.isShowSkeleton || !this.isShowTabela);
      this.isShowTabela = !this.isShowMessage;

      return itensFiltrado;
    },
  },
  methods: {
    voltar() {
      this.$router.push({
        name: "Home",
        params: {
          tipopessoa: JSON.parse(localStorage.getItem("TipoPessoa")),
        },
      });
    },
  },
};
</script>

<style  scoped>
html {
  scroll-behavior: smooth;
}

a {
  text-decoration: none;
}

a,
a:active,
a:hover,
a:visited {
  color: #439763;
  font-weight: bold;
}

.buttons {
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-voltar {
  color: #888888;
  font-size: 17px;
  font-weight: 400;
  border: 1px solid #d6d6d6;
  border-radius: 50px;
  padding: 9px 0 9px 0;
  width: 120px;
}

.button-voltar:hover {
  color: #0d0d0d;
  border-color: #7d7d7d;
  transition: all 0.2s ease-in-out;
}

.icone-interrogacao {
  padding: 1%;
  color: white;
  background: radial-gradient(
    circle closest-side,
    rgb(61, 174, 43) 0%,
    #3dae2b 98%,
    rgba(0, 0, 0, 0) 100%
  );
}

.card-header-title-coparticipacao {
  font-size: 17px;
  border: 1px #77b48e solid;
  padding: 9px 0 9px 0;
  border-radius: 50px;
}

:target {
  scroll-margin-top: 0.12em;
}

.card-pesquisa {
  font-family: UnimedSans-Regular;
  display: flex;
  height: 120px;
  padding: 0 5%;
  background-color: #439763;
}

.pesquisa-item {
  width: 100%;
}

.card-tabelas {
  margin: auto;
  padding-top: 50px;
}

.block-skeleton {
  height: 120px;
}

.table-skeleton /deep/ th {
  height: 36px;
  background-color: #3dae2b;
}

.table-skeleton /deep/ th:first-child {
  width: 10%;
}

.table-skeleton /deep/ th:nth-child(2) {
  width: 20%;
}

.table-skeleton /deep/ th:nth-child(3) {
  width: 55%;
}

.table-skeleton /deep/ th:nth-child(4) {
  width: 15%;
}

.table-skeleton /deep/ td div {
  width: 100%;
}

.table-skeleton /deep/ th .b-skeleton-text,
td .b-skeleton-text {
  height: 36px;
}

.mensagem {
  font-size: 24px;
  text-align: center;
  padding-bottom: 40px;
}

#tabelaCoparticipacao /deep/ thead {
  background-color: #3dae2b;
  color: #ffffff;
  border: none;
}

/deep/ .table {
  font-size: 13px;
}

/deep/ .table > :not(:first-child) {
  border: none;
}

/deep/ .table tbody tr td {
  border: none;
}

.custom-pagination /deep/ .page-item.active .page-link {
  color: #fff;
  border-color: #3dae2b;
  background-color: #3dae2b;
}

.custom-pagination /deep/ li.page-item.disabled span.page-link {
  color: #6c757d;
}

.custom-pagination /deep/ .page-item .page-link {
  color: #3dae2b;
}

@media (min-width: 0) {
  .buttons {
    flex-direction: column;
  }

  .button-voltar {
    margin: 10px 10px 3px;
  }

  .table-skeleton {
    display: none;
  }

  .block-skeleton {
    display: block;
  }
}

@media (min-width: 768px) {
  .buttons {
    flex-direction: row;
  }

  .button-voltar {
    margin: 10px;
  }
}

@media (min-width: 780px) {
  .card-tabelas {
    padding: 30px 5%;
  }

  .table-skeleton {
    display: inline-table;
  }

  .block-skeleton {
    display: none;
  }
}

@media (min-width: 992px) {
  .card-tabelas {
    padding: 40px 0;
    width: 920px;
  }
}

@media only screen and (min-device-width: 500px) and (max-device-width: 1840px) {
  .card-header-title-coparticipacao {
    justify-content: center;
    text-align: center;
    width: 500px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}

@media only screen and (min-device-width: 281px) and (max-device-width: 500px) {
  .icone-interrogacao {
    margin: 4% 0 0 5%;
    padding: 1%;
  }

  .card-header-title-coparticipacao {
    justify-content: center;
    text-align: center;
    width: 350px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}
@media only screen and (max-device-width: 280px) {
  .icone-interrogacao {
    margin: 4% 0 0 5%;
    padding: 1%;
  }
  .card-header-title-coparticipacao {
    display: flex;
    justify-content: center;
    text-align: center;
    width: 275px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}

@media (min-width: 1280px) {
  .icone-interrogacao {
    margin: 4% 0 0 5%;
  }
}
@media only screen and (min-device-width: 1103px) and (max-device-width: 3400px) {
  .icone-interrogacao {
    margin: 0 0 0 5%;
    padding: 1%;
  }

  .card-header-title-coparticipacao {
    justify-content: center;
    text-align: center;
    width: 35em;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}
</style>